var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "osfQuizExternalUrl" }, [
      _c("iframe", {
        attrs: {
          src: _vm.externalUrl,
          width: "100%",
          height: "100%",
          frameborder: "0",
        },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }